import React from 'react';
import { useSelector } from 'react-redux';

import Tooltip from 'components/Tooltip';
import Button from 'components/V2/Button';
import { REQUEST_SANDBOX_TOOLTIP } from 'helper/constant';
import useRequestSandbox from 'hooks/useRequestSandbox';

import { selectLoggedInUser } from 'redux/selectors/auth';
import { selectSetupGuideStatus } from 'redux/selectors/general';

import styles from './switchEnvironment.module.css';

// Page bar counterpart to the setup guide's "Request Sandbox" button, shown to owners when no
// sandbox exists yet. Disabled until the company agreement is approved, and after a request
// has already been sent.
function RequestSandboxButton() {
    const customer = useSelector(selectLoggedInUser);
    const guideStatus = useSelector(selectSetupGuideStatus);
    const requestSandbox = useRequestSandbox();

    const isAgreementApproved =
        !customer?.company?.meta_data?.agreement_status ||
        customer?.company?.meta_data?.agreement_status === 'approved';

    let disabled = false;
    let tooltip = '';

    if (!isAgreementApproved) {
        disabled = true;
        tooltip = REQUEST_SANDBOX_TOOLTIP.AGREEMENT_PENDING;
    } else if (guideStatus?.sentSandboxRequest) {
        disabled = true;
        tooltip = REQUEST_SANDBOX_TOOLTIP.REQUEST_SENT;
    }

    return (
        <Tooltip title={disabled ? tooltip : ''} placement="bottom" arrow>
            <span className={styles.requestSandboxWrapper}>
                <Button
                    intent="secondary"
                    size="sm"
                    disabled={disabled}
                    onClick={() => requestSandbox()}
                >
                    Request Sandbox
                </Button>
            </span>
        </Tooltip>
    );
}

export default RequestSandboxButton;
